import { makeStyles } from '@mui/styles'
import { Typography, Slider } from '@mui/material'

type SliderProps = {
    onChange?: (value: number) => void
    label?: string
    value?: number
    min?: number
    max?: number
    defaultValue?: number
    stepValue?: number
    disabled?: boolean
    required?: boolean
    displayLabel?: 'auto' | 'on' | 'off'
}

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
})

const SliderControl = (props: SliderProps) => {
    const {
        onChange,
        label,
        value,
        min = 0,
        max = 100,
        defaultValue = 0,
        stepValue,
        displayLabel = 'auto',
        disabled,
        required,
    } = props
    const classes = useStyles()

    const handleChange = (event: any, newValue: number | number[]) => {
        if (onChange) {
            onChange(newValue as number)
        }
    }

    return (
        <div className={classes.root}>
            {label && (
                <Typography gutterBottom>
                    {label}
                    {required && <label style={{ color: '#d32f2f' }}>{' *'}</label>}
                </Typography>
            )}
            <Slider
                defaultValue={defaultValue}
                value={value}
                onChange={handleChange}
                valueLabelDisplay={displayLabel}
                step={stepValue}
                marks={stepValue ? true : false}
                min={min}
                max={max}
                disabled={disabled}
            />
        </div>
    )
}

export default SliderControl
